module.exports = __webpack_public_path__ + "img/dave-hoefler-2Mv2Ph9aMEc-unsplash.59b63e15.jpg";